import { Provider } from 'react-redux'
import { RouterProvider } from 'react-router-dom'
import { Toaster } from 'sonner'
import { router } from '@/app/router/router'
import { store } from '@/app/store/store'

export function App() {
  return (
    <Provider store={store}>
      <RouterProvider router={router} />
      <Toaster
        position="top-right"
        richColors
        duration={3500}
        closeButton
        visibleToasts={3}
        toastOptions={{
          duration: 3500,
          closeButton: true,
        }}
      />
    </Provider>
  )
}
